/**
 * Import Lib & assets
 */

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

 const Svg = styled.svg`
  display: none;

  ${t.mixins.sm(`
    display: inline;
  `)}
 `;

/**
 * scroll component is..
 */

const Svg__scroll = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" width="17" height="11">
    <path stroke="#04528D" strokeWidth="2" fill="none" d="M15 2.477l-6.857 6.31-6.857-6.31" />
  </Svg>
);

export default Svg__scroll;

Svg__scroll.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Svg__scroll.defaultProps = {
  style: {},
};

/*
    import Svg__scroll from 'components/svg/scroll/svg__scroll'
    <Svg__scroll />
  */
